/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto } from '../../models/platform-api-result-of-data-source-result-dto-of-user-group-simple-dto';
import { PlatformDataSourceQuery } from '../../models/platform-data-source-query';

export interface PostUsergroupsQueryDatasource$Params {
      body: PlatformDataSourceQuery
}

export function postUsergroupsQueryDatasource(http: HttpClient, rootUrl: string, params: PostUsergroupsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto>> {
  const rb = new RequestBuilder(rootUrl, postUsergroupsQueryDatasource.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfUserGroupSimpleDto>;
    })
  );
}

postUsergroupsQueryDatasource.PATH = '/api/usergroups/query/datasource';
